// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KspN7N7rs5RdtrqFPqKe {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/AppointmentBooking/components/AppointmentBookingHeader/AppointmentBookingHeader.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC","sourcesContent":[".wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `KspN7N7rs5RdtrqFPqKe`
};
export default ___CSS_LOADER_EXPORT___;
